<mat-card class="settingsBody">
    <mat-card-header>
        <mat-card-title class="settings-heading mat-card-title">
            Account Details
        </mat-card-title>
    </mat-card-header>
    <tab [tabs]="tabs"></tab>
</mat-card>
